import { useState } from "react";
import axios from "axios";
import { getAccessToken } from "../utils/authSession";

const useDelete = (url) => {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const access_token = getAccessToken();

  const deleteData = async () => {
    setError(null);
    try {
      setLoading(true);
      const response = await axios.delete(url, {
        headers: {
          Authorization: `Bearer ${access_token}`,
        },
      });
      // console.log({ response });
      setData(response?.data);
    } catch (err) {
      setError(err);
    } finally {
      setLoading(false);
    }
  };

  const deleteMultiple = async (body) => {
    try {
      setLoading(true);
      const response = await axios.delete(url, {
        headers: {
          Authorization: `Bearer ${access_token}`,
        },
        data: body,
      });
      setData(response?.data);
      setError(null);
    } catch (err) {
      setError(err);
    } finally {
      setLoading(false);
    }
  };

  return { data, loading, error, deleteData, deleteMultiple };
};

export default useDelete;
